export default __webpack_public_path__ + "static/media/math.f6b3dc38104df4d1a9219e435e15541f.png";